import { render, staticRenderFns } from "./ModalNuevoCurso.vue?vue&type=template&id=847168a6&"
import script from "./ModalNuevoCurso.vue?vue&type=script&lang=js&"
export * from "./ModalNuevoCurso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports